<script setup>
import { RouterLink } from 'vue-router';
import { useI18n } from 'vue-i18n';

defineProps({
  selectedTicket: { type: Object, required: true },
  contactLink: { type: [String, Object], default: '' },
  conversationLink: { type: [String, Object], default: '' },
  imovelLink: { type: [String, Object], default: '' },
});

const { t } = useI18n();
</script>

<template>
  <section
    class="grid gap-3 rounded-lais border border-lais-border-soft bg-white px-4 py-3"
  >
    <h3 class="text-[13px] font-semibold text-lais-text">
      {{ t('SUPPORT_TICKETS.CONTEXT.TITLE') }}
    </h3>
    <div class="grid gap-2 text-[12px] text-lais-text-muted">
      <p v-if="selectedTicket.context.contact">
        <strong>
          {{ t('SUPPORT_TICKETS.CONTEXT.CONTACT_LABEL') }}
        </strong>
        <RouterLink v-if="contactLink" :to="contactLink" class="text-lais-link">
          {{ selectedTicket.context.contact.label }}
        </RouterLink>
        <span v-else>{{ selectedTicket.context.contact.label }}</span>
      </p>
      <p v-if="selectedTicket.context.conversation">
        <strong>
          {{ t('SUPPORT_TICKETS.CONTEXT.CONVERSATION_LABEL') }}
        </strong>
        <RouterLink
          v-if="conversationLink"
          :to="conversationLink"
          class="text-lais-link"
        >
          {{ selectedTicket.context.conversation.label }}
        </RouterLink>
        <span v-else>
          {{ selectedTicket.context.conversation.label }}
        </span>
      </p>
      <p v-if="selectedTicket.context.imovel">
        <strong>
          {{ t('SUPPORT_TICKETS.CONTEXT.PROPERTY_LABEL') }}
        </strong>
        <RouterLink v-if="imovelLink" :to="imovelLink" class="text-lais-link">
          {{ selectedTicket.context.imovel.label }}
        </RouterLink>
        <span v-else>{{ selectedTicket.context.imovel.label }}</span>
      </p>
      <p v-if="selectedTicket.context.visit">
        <strong>
          {{ t('SUPPORT_TICKETS.CONTEXT.VISIT_LABEL') }}
        </strong>
        {{ selectedTicket.context.visit.label }}
      </p>
      <p v-if="selectedTicket.context.source">
        <strong>
          {{ t('SUPPORT_TICKETS.CONTEXT.SOURCE_LABEL') }}
        </strong>
        {{ selectedTicket.context.source }}
      </p>
      <p v-if="selectedTicket.context.summary">
        <strong>
          {{ t('SUPPORT_TICKETS.CONTEXT.SUMMARY_LABEL') }}
        </strong>
        {{ selectedTicket.context.summary }}
      </p>
    </div>
  </section>
</template>
